import { render } from "./Links.vue?vue&type=template&id=34ae19a4&scoped=true"
import script from "./Links.vue?vue&type=script&lang=js"
export * from "./Links.vue?vue&type=script&lang=js"

import "./Links.vue?vue&type=style&index=0&id=34ae19a4&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.9.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ae19a4"]])

export default __exports__